// src/app/modules/authentication/application/register/register.effects.ts

import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import {
  checkEmailAvailability,
  checkEmailAvailabilitySuccess,
  checkEmailAvailabilityFailure,
} from './register.actions';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

@Injectable()
export class RegisterEffects {
  checkEmail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(checkEmailAvailability),
      switchMap(({ email }) =>
        this.http
          .post<any>(`${environment.apiDomain}/v3/authentication/check-email-exist`, { email })
          .pipe(
            map((response) => {
              // Extract exists flag safely
              const exists = response?.data?.exists === true;

              // Extract message (fallback if missing)
              const message = response?.message || 'This email is already taken';

              if (exists) {
                // Email is TAKEN → failure with message
                return checkEmailAvailabilityFailure({
                  error: { message },
                });
              } else {
                // Email is FREE → success
                return checkEmailAvailabilitySuccess({ available: true });
              }
            }),
            catchError((error) => {
              // Network error or 500
              const message =
                error?.error?.message ||
                error?.message ||
                'Unable to check email. Please try again.';
              return of(
                checkEmailAvailabilityFailure({
                  error: { message },
                })
              );
            })
          )
      )
    )
  );

  constructor(private actions$: Actions, private http: HttpClient) {}
}